<template>
	<div class="p-b-70">
        <!-- 初始空白 -->
		<div v-if="loading"></div>
		<!-- 授权加载 -->
		<div v-else>
            <div class="shop">
                <div class="banner">
                    <el-carousel height="100vw" @change="bannerSlide" indicator-position="none">
                        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                            <img :src="item" alt="">
                        </el-carousel-item>
                    </el-carousel>
                    <div class="tips">
                        <span>{{ bannerIndex }}/{{bannerList.length}}</span>
                        <h3>{{ produInfo.content.info[0] }}</h3>
                    </div>
                </div>

                <div class="form-name" id="form">添加收货信息</div>
                <el-form :model="form" :rules="rules" ref="form" label-width="90px">
                    <el-form-item label="收货人" prop="real_name">
                        <el-input v-model="form.real_name" placeholder="请输入姓名" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input  v-model.number="form.phone" placeholder="请输入手机号" />
                        <div class="el-form-item__error" v-if="showError">{{showText}}</div>
                    </el-form-item>
                    <el-form-item label="验证码" prop="verify_code">
                        <el-input v-model="form.verify_code" placeholder="请输入验证码" @input="handleSms" class="sms">
                            <el-button @click="getCode" :disabled="timer"  slot="suffix"> {{ timer ? `${count}秒后重新获取` : '获取验证码' }}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="收货地址" prop="address" class="address">
                        <el-input type="textarea" :rows="5" v-model="form.address" placeholder="省份城市及详细街道、门牌号、小区、乡镇、村等" />
                    </el-form-item>
                </el-form>

                <div class="cbtn" @click="submitForm">
                    <div class="text">立即购买</div>
                </div>


                <div class="detail">
                    <img class="lazy" :data-src="item" src="./../../assets/images/lazy.jpg" alt="" v-for="(item, index) in imagesList" :key="index">
                </div>
            </div>
        
            <div class="footer">
                <div class="name">{{ produInfo.content.info[1].slice(0,4) }}<b>{{ produInfo.price/100 }}</b>元</div>
                <div class="text" @click="submitForm">
                    <div class="breathe">立即抢购</div>
                </div>
            </div>
        </div>
        <!-- 支付结果查询 -->
		<div class="mask" v-if="showWxRes">
			<div class="panel">
                <h5>恭喜您购买成功</h5>
                <div class="grey">
                    <h6>收货信息：</h6>
                    <div class="info">
                        <div>订单编号:{{ orderCode }}</div>
                        <div>商品名称:{{ produInfo.name }}</div>
                        <div>收 货 人:{{ form.real_name }}</div>
                        <div>手 机 号:{{ form.phone }}</div>
                        <div>收货地址:{{ form.address }}</div>
                    </div>
                </div>
                <div>温馨提示：如需要变更收货信息请联系沐风老师</div>
                <!-- <div class="btn">我已知晓</div> -->
			</div>
		</div>

         <!-- 活动结束 -->
		<div class="mask" v-if="actOver !== ''">
			<div class="panel">
                <div class="over">{{actOver}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { clickThrottle, getQueryVariable } from '@/utils/index'

    var checkPhone = (rule, value, callback) => {
		const regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/
		if (value === '') {
			return callback(new Error('手机号不能为空'))
		} else if (!regPhone.test(value)) {
			callback(new Error('请输入正确的手机号'))
		} else {
			callback()
		}
	};

	export default {
		data () {
			return {
                actOver: '',
                loading:true,
                openId:'',
                productId:1,
				produInfo:{},
                bannerIndex:1,
                bannerList:[],
				imagesList:[],
                timer:false,
				count: 60,
				showText:'',
				showError:false,
				form: {},
				rules: {
                    address:[{ required: true, message: '请输入收货人地址', trigger: 'blur' }, { min: 10, message: '请输入正确的收货地址', trigger: 'blur' }],
                    real_name:[{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
					verify_code:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ validator: checkPhone, trigger: 'blur' }
					]
				},
				phoneLcok:false,
				smsLock:false,
                wxPoll: null,
                showWxRes: false,
                orderCode:'',
				wWidth:'',
				wHeight:''
			}
		},
		created(){
            this.productId = this.$route.query.productId || 1   //产品ID
            this.checkWX()
            // this.openId = 'oknjf6RpWevs8YaZdQrOS_18RLSw'
			this.wWidth = document.documentElement.clientWidth
			this.wHeight = document.documentElement.clientHeight

			this.getProduct()
		},
		methods:{
            checkWX(){
				var ua = navigator.userAgent.toLowerCase();
				var isWeixin = ua.indexOf('micromessenger') != -1;
				if (!isWeixin) {
					document.head.innerHTML = '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">';
					document.body.innerHTML = '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>';
				}else{
					this.getProduct()
                    let code = getQueryVariable("code")
                    code ? this.getOpenID(code) : this.getAuthCode()
				}
			},
            getAuthCode(){
                let localPath = window.location.href
                let newPath = encodeURIComponent(localPath)
				let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2238825427205438&redirect_uri="+newPath+"&response_type=code&scope=snsapi_base#wechat_redirect"
				window.location.replace(url)
			},
            getOpenID(code){
				axios({
					method:"POST",
					url:`${this.$backend}/launch/getOpenId`,
					data:{
						code: code
					}
				}).then(res => {
					if(res.data.code == 1){
						this.openId = res.data.data.openid
					}else{
						this.$message({
							message: '系统繁忙，请刷新页面重试',
							type: 'warning'
						})
					}
				})
			},
      		getProduct(){
				axios({
					method:'POST',
					url: `${this.$backend}/launch/getProductInfo`,
					data:{
						product_id: this.productId
					}
				}).then(res => {
                    if(res.data.code == 1){
                        this.loading = false
                        this.produInfo = res.data.data
                        this.bannerList = res.data.data.content.banner
                        this.imagesList = res.data.data.content.detail
                        window.addEventListener('scroll',this.lazyLoad)
                    }
                    if(res.data.code == -4){
                        this.actOver = res.data.msg
                    }
				})
			},
            bannerSlide(index){
                this.bannerIndex = index + 1
            },
            lazyLoad(e){
                const images = [...document.querySelectorAll('.lazy')]
                const clientH = document.documentElement.clientHeight
                const scrollTop = document.documentElement.scrollTop
                for (let i = 0; i < images.length; i++) {
                    if (images[i].offsetTop < clientH + scrollTop) {
                        images[i].setAttribute('src', images[i].getAttribute('data-src'))
                    }
                }
            },
            handlePhone(val){  
				if(val.length > 6){
					if(this.phoneLcok){
						return false
					}
					this.phoneLcok  = true
					let that = this
					setTimeout(() => {
						that.phoneLcok  = false
					},2000)
				}else{
					this.phoneLcok  = false
				}
			},
			handleSms(val){
				this.form.verify_code = val.slice(-6)
				if(this.smsLock){
					return
				}
				this.smsLock = true
			},
			getCode(){
				if(!this.form.phone){
					this.showError = true
					this.showText = '请输入手机号'
					return false
				}
				const regPhone = /^1[3|4|5|6|7|8|9][0-9]{9}$/
				if(!regPhone.test(this.form.phone)){
					this.showError = true
					this.showText = '请输入正确的手机号'
					return false
				}
				this.showError = false
				axios({
					method:"POST",
					url: `${this.$backend}/launch/sendVerifySms`,
					data:{
						phone: this.form.phone
					}
				}).then(res => {
					if(res.data.code == 1){
						this.countDown()
					}else{
						this.$message({
							message: res.data.msg,
							type: 'warning'
						})
					}
				})
			},
			countDown(){
				if(this.count > 0){
					this.timer = true
					setTimeout(() => {
						this.count--
						this.countDown()
					},1000)
				}else{
					this.timer = false
					this.count = 60
				}
			},
			submitForm() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						if(!clickThrottle(2000)) return
						this.login()
					} else {
						window.scrollTo({
							top:150,
							behavior:'smooth'
						})
						return false
					}
				})
			},
			login(){
                this.form.product_id = this.productId
                this.form.openid = this.openId
				axios({
					method:"POST",
					url:`${this.$backend}/launch/submitFormPay`,
					data:this.form
				}).then(res => {
					if(res.data.code == 1){
                        let data = res.data.data
                        this.orderCode = data.order_code
                        this.wxPrePay(data)
					}else{
						this.$message({message: res.data.msg});
					}
				})
			},
			//微信支付
			wxPrePay(param){
				let that = this
				WeixinJSBridge.invoke('getBrandWCPayRequest', {
					"appId": param.appId,     
					"timeStamp": param.timeStamp,     
					"nonceStr": param.nonceStr,     
					"package": param.package,
					"signType":  param.signType,
					"paySign": param.paySign 
				},
				function(res) {
					if (res.err_msg == "get_brand_wcpay_request:ok") {
						that.wxPolling()
						setTimeout(() => {
							clearInterval(that.wxPoll)
						},180000)
					}
				});
			},
            wxPolling(){
				this.wxPoll = setInterval(() => {
					this.getPayRes()
				},1000)
			},
            getPayRes(){
                axios({
					method:"POST",
					url:`${this.$backend}/launch/payResult`,
					data:{
                        code: this.orderCode
                    }
				}).then(res => {
					if(res.data.code == 1){
                        this.showWxRes = true
                        clearInterval(this.wxPoll)
					}else{
						this.$message({message: res.data.msg});
					}
				})
            }
		}
	}
</script>


<style scoped>
    .banner{position: relative;}
    .banner .tips{position: absolute;right: 0;bottom: 0;z-index: 2;text-align: center;color: #fff;width: 100%;}
    .banner span{display: inline-block;width: 55px;background: rgba(0,0,0,.5);border-radius: 13px;line-height: 26px;position: absolute;right: 5px;bottom: 60px;}
	.banner h3{background: rgba(0,0,0,.5);width: 100%;line-height: 55px;font-size: 1.5rem;white-space: nowrap;font-weight: normal;letter-spacing: 4px;}
    
    .form-name{font-size: 22px;color: #333;font-weight: bold;text-align: center;line-height: 40px;margin-top: 20px;border-bottom: 1px solid #bbb;margin-bottom: 8px;padding-bottom: 15px;}
    .shop .el-form-item{border-bottom: 1px solid #bbb;margin-bottom: 8px;padding-bottom: 8px;}
    .cbtn{margin:30px;padding: 10px;background: #BD0700;text-align: center;border-radius: 30px;text-align: center;}
	.cbtn .text{animation: testAnimation 1.5s linear infinite;color: #fff;font-size:30px;letter-spacing: 2px;font-weight: bold;}
	/* css3 */
	@keyframes testAnimation {
		0%{
			transform: scale(.9);
		}
		50%{
			transform: scale(1.1);
		}
		100%{
			transform: scale(.9);
		}
	}

    .detail img{display: block;}
    .footer{background-image: url('./../../assets/images/btn1.png');bottom: 0px;}
    .footer .name{color: #333;font-size: 24px;position: fixed;bottom: 8px;left: 8px;}
    .footer b{color: #CC0600;font-size: 28px;}
    .footer .text{bottom: 5px;right: 5px;}

    .panel{border-radius: 20px;width: calc(100% - 80px);min-width: 280px;height: 420px;padding: 15px 20px;margin-top: 25%;background: #fff;margin-left: auto;margin-right: auto;max-height: 666px;max-width: 641px;}
	.panel h5{text-align: center;font-size: 20px;font-weight: normal;}
    .panel .grey{background: #f6f7f9;padding: 15px;margin: 20px 0 10px;height: 215px;overflow: auto;}
    .panel h6{font-size: 18px;font-weight: normal;padding: 10px 0;}
    .panel .grey div{line-height: 28px;}
    .panel .btn{padding: 10px;border-radius: 10px;margin: 15px 50px 0;font-size: 20px;font-weight: bold;color: #fff;background: linear-gradient(90deg, #CC0600 0%, #BD0700 100%);text-align: center;}
    .panel .over{color: #CC0600;max-width: 240px;margin: auto;font-size: 28px;font-weight: bold;padding-top: 50px;}

	
	@media screen and (max-width:350px){
		.cbtn .text{font-size:1.8rem;}
		.panel{width: calc(100% - 50px);padding: 20px 15px;}
		.footer .name{font-size: 1rem;}
		.footer .breathe{font-size:1.5rem;}
	}

</style>

<style>
    .shop .el-input__inner,.shop .el-textarea__inner{border: none;font-size: 16px;}
    .shop .el-form-item__label{color: #666;font-size: 16px;}
    .shop .el-input__suffix{right: 0;top: -8px;}
    .shop .el-button.is-disabled, .shop .el-button.is-disabled:hover,
    .shop .el-button{background: #BD0700;border: none;color: #fff;line-height: 34px;width: 130px;font-size: 17px;border-radius: 0;padding-left: 0;padding-right: 0;}
    .shop .el-form-item__error{top: 30px;}
    .shop .address .el-form-item__error{top: 60px;}
    .shop .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{display: none;}

	@media screen and (max-width:342px){
		.shop .el-form-item__label{font-size: 0.8rem;}
	}
</style>



// WEBPACK FOOTER //
// src/views/shop/index.vue